"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideNavSubMenu = exports.SideNavMenuItem = exports.SideNavMenu = exports.SideNav = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactProSidebar = require("react-pro-sidebar");
var _reactstrap = require("reactstrap");
require("react-pro-sidebar/dist/css/styles.css");
var _Icon = require("../Icon");
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SideNavMenu = props => {
  return /*#__PURE__*/_react.default.createElement(_reactProSidebar.Menu, props);
};
exports.SideNavMenu = SideNavMenu;
SideNavMenu.defaultProps = {
  popperArrow: false,
  innerSubMenuArrows: false,
  subMenuBullets: true
};
SideNavMenu.propTypes = {
  /** Shape of the menu icons */
  iconShape: _propTypes.default.oneOf(['square', 'round', 'circle']),
  /** if true, an arrow will be displayed when sidebar collapsed to point to sub-menu wrapper */
  popperArrow: _propTypes.default.bool,
  /** if true, arrows will be displayed for each inner submenu */
  innerSubMenuArrows: _propTypes.default.bool,
  /** if true, bullets will be displayed for each inner submenu/menuItem */
  subMenuBullets: _propTypes.default.bool
};
const SideNavSubMenu = props => {
  return /*#__PURE__*/_react.default.createElement(_reactProSidebar.SubMenu, props);
};
exports.SideNavSubMenu = SideNavSubMenu;
SideNavSubMenu.defaultProps = {
  defaultOpen: false
};
SideNavSubMenu.propTypes = {
  /** Title for the submenu */
  title: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.elementType, _propTypes.default.string]),
  /** Icon for submenu */
  icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.elementType]),
  /** Set if the submenu is open by default */
  defaultOpen: _propTypes.default.bool,
  /** Set open value if you want to control the state */
  open: _propTypes.default.bool,
  /** Add a prefix to the submenu */
  prefix: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.elementType]),
  /** Add a suffix to the submenu */
  suffix: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.elementType]),
  /** Callback function called when submenu state changes `(open: boolean)=>{}` */
  onOpenChange: _propTypes.default.func
};
const SideNavMenuItem = props => {
  return /*#__PURE__*/_react.default.createElement(_reactProSidebar.MenuItem, props);
};
exports.SideNavMenuItem = SideNavMenuItem;
SideNavMenuItem.defaultProps = {};
SideNavMenuItem.propTypes = {
  /** Icon for the menu item */
  icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.elementType]),
  /** Set active menu items */
  active: _propTypes.default.bool,
  /** Add a prefix to the menuItem */
  prefix: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.elementType]),
  /** Add a suffix to the menuItem */
  suffix: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.elementType])
};
class SideNav extends _react.default.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      collapsed: this.props.isCollapsed,
      toggled: false
    });
    (0, _defineProperty2.default)(this, "sidenavWrapper", /*#__PURE__*/_react.default.createRef(null));
    (0, _defineProperty2.default)(this, "handleCollapsedChange", () => {
      var _this$sidenavWrapper;
      const {
        collapsed
      } = this.state;
      this.setState({
        collapsed: !collapsed
      });
      const ele = (_this$sidenavWrapper = this.sidenavWrapper) === null || _this$sidenavWrapper === void 0 ? void 0 : _this$sidenavWrapper.current;
      ele.style.pointerEvents = "none";
      let resetTimer = setTimeout(() => {
        ele.style.pointerEvents = "all";
        clearTimeout(resetTimer);
      }, 250);
    });
    (0, _defineProperty2.default)(this, "handleToggleSidebar", value => {
      this.setState({
        toggled: value,
        collapsed: false
      });
    });
  }
  render() {
    const {
      children,
      footerContent,
      logoUrl,
      betatag
    } = this.props;
    const {
      toggled,
      collapsed
    } = this.state;
    let {
      NavLink: NavLinkContext
    } = this.props;
    NavLinkContext = NavLinkContext || _reactstrap.NavLink;
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: this.sidenavWrapper,
      className: "sidenav__wrapper ".concat(toggled ? 'toggled' : '', " ").concat(collapsed ? 'collapsed' : 'expanded')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "sidenav__icon-arrow ".concat(collapsed ? 'collapsed' : 'expanded'),
      onClick: this.handleCollapsedChange.bind(this, 'expandWithClick')
    }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: ['fas', 'chevron-right']
    }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: ['fas', 'thumbtack']
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "sidenav__icon-toggle",
      onClick: () => this.handleToggleSidebar(true)
    }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: ['fas', 'bars']
    })), /*#__PURE__*/_react.default.createElement(_reactProSidebar.ProSidebar, {
      breakPoint: "sm",
      toggled: toggled,
      onToggle: this.handleToggleSidebar
    }, betatag && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "place-exchange-logo__beta-sticker"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "place-exchange-logo__beta-text"
    }, "BETA")), /*#__PURE__*/_react.default.createElement(_reactProSidebar.SidebarHeader, null, /*#__PURE__*/_react.default.createElement(NavLinkContext, {
      to: logoUrl,
      href: logoUrl,
      "data-testid": "px-homepage-cta"
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "px__logo",
      alt: "place exchange logo",
      src: "https://www.placeexchange.com/wp-content/themes/placeexchange/images/px_logo_light.png"
    }))), /*#__PURE__*/_react.default.createElement(_reactProSidebar.SidebarContent, null, children), /*#__PURE__*/_react.default.createElement(_reactProSidebar.SidebarFooter, null, footerContent)));
  }
}
exports.SideNav = SideNav;
SideNav.defaultProps = {
  isCollapsed: true,
  logoUrl: '',
  betatag: false,
  NavLink: false
};
SideNav.propTypes = {
  /** collapsed status of the sidebar */
  isCollapsed: _propTypes.default.bool,
  /** Set active menu items */
  active: _propTypes.default.bool,
  /** Add a prefix to the menuItem */
  prefix: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.elementType]),
  /** Add a suffix to the menuItem */
  suffix: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.elementType]),
  /** Render footer HTML/React node */
  footerContent: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.elementType]),
  /** Redirect URL on logo click */
  logoUrl: _propTypes.default.string,
  /** BETA sticker */
  betatag: _propTypes.default.bool,
  /** [optional] Reference a NavLink component with the same context as the custom links defined within an instance of the SideNav menu */
  NavLink: _propTypes.default.any
};